import './InlinePhoto.scss';

const InlinePhoto = ({ img }) => {
  return <div className="inline-photo" style={{ backgroundImage: `url(${img})` }}></div>;
};

export default InlinePhoto;
